import {createActions} from 'reduxsauce';

export const {Types: CollectionsTypes, Creators: CollectionActionCreators} = createActions ({
    collectionStart: null,
    collectionSuccess: ['collection'],
    collectionFailure: ['error']
});